import { iniAndroidCallbacks } from '@/api/android/callbacks';
import '@/assets/scss/app.scss';
import i18n from '@/i18n';
import { gnbScrollSpy, toppingGroupScrollSpy } from '@/libs/vue-scroll-spy';
import { logger } from '@/logger';
import { deleteASPSESSIONIDCookies, handleGlobalError } from '@/utils';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import App from './app.vue';
import router from './router';

// dayjs 플러그인 사용 설정
dayjs.extend(isBetween);

const app = createApp(App);

// 라우터
app.use(router);

// Pinia
app.use(createPinia());

// vh 단위를 브라우저 높이로 재정의
//const vh = window.innerHeight * 0.01;
//document.documentElement.style.setProperty('--vh', `${vh}px`);

// 국제화 설정
app.use(i18n);

// GNB
gnbScrollSpy(app);
toppingGroupScrollSpy(app);

// 로거 설정
app.use(logger);

// 안드로이드 콜백 함수 초기화
iniAndroidCallbacks();

// 글로벌 에러 처리
app.config.errorHandler = (error: unknown) => {
  handleGlobalError(error, 'Vue ErrorHandler');
};

// Vue 외부에서 발생하는 글로벌 에러 처리
window.onerror = function (message, _url, _line, _col, error) {
  handleGlobalError(error ?? message, 'Global JS Error');
};

// 비동기 이벤트에서 발생하는 글로벌 에러 처리
window.onunhandledrejection = function (event) {
  handleGlobalError(event.reason, 'Unhandled Promise Rejection');
};

// 세션아이디 쿠키 삭제 (세션아이디 값이 계속 새로 생성되어 IIS로그가 길어지는 문제)
deleteASPSESSIONIDCookies();

app.mount('#app');
